import React from 'react';
import PropTypes from 'prop-types';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import Required from 'menus/ui_components/Required';

import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

const VariantFieldSet = ({
  title,
  selectionSatisfied,
  required,
  children,
  helperText
}) => {
  return (
    <FormControl component="fieldset">
      <Box mb={1}>
        <FormLabel>
          <Typography component="span" variant="h4">
            {title}
          </Typography>
          {required && (
            <Required selected={selectionSatisfied}> Required</Required>
          )}
          {helperText && (
            <Box mt={1}>
              <Typography>{helperText}</Typography>
            </Box>
          )}
        </FormLabel>
      </Box>

      {children}
    </FormControl>
  );
};

VariantFieldSet.propTypes = {
  title: PropTypes.string,
  selectionSatisfied: PropTypes.bool,
  required: PropTypes.bool,
  helperText: PropTypes.string,
  children: CHILDREN_PROPTYPES
};

export default VariantFieldSet;
